$(window).resize(function () {
  let colors_scrollbar = document.querySelector('.scrollbar-filter.colors');
  let width = $(window).width();
  if (width >= 992) {
    if (colors_scrollbar) {
      Scrollbar.init(colors_scrollbar)
    }
    removeOpenedWindows();
    if (checkIfExists('header #navigation .navbar-nav')) {
      setTimeout(() => {
        // Recalculating the with of the Dropdown menu in the navigation
        let nav_width = $('header #navigation .navbar-nav').width();
        $('header #navigation .nav-item .dropdown-menu').css({
          'width': nav_width - $('header #navigation .highlighted').width(),
          'left': $('header #navigation .nav-item.highlighted').width() + 11
        });

        // Closing the menu in case the window is resized above 992 pixels
        // mobile_menu.API.close();
      }, 100)
    }
    device_state = 'desktop';
  } else {
    device_state = 'tablet';
    if (width < 576) {
      if (device_state != 'mobile') {
        // Preventing it from running more than once

        // Initializing colors scrollbar so we can destroy it.
        if (colors_scrollbar) {
          Scrollbar.init(colors_scrollbar)
          setTimeout(() => {
            Scrollbar.destroy(colors_scrollbar)
          }, 10)
        }
      }
      device_state = 'mobile';
    }
  }
})
